import { useFormContext, Controller } from 'react-hook-form';
import styles from '../index.module.scss';
import { FormControl } from '@mui/material';
import { AMBULATORY_OPTIONS } from '../../../../hooks/intake-options';
import { ReactComponent as ExpandMoreIcon } from '../../../../../../../../assets/icons/patientProfileIcons/expandMoreIcon.svg';
import classNames from 'classnames';
import Select from '../../../../../../../Inputs/Select';
import useIntakeBlockToggle, {
  intakeBlocksEnum,
} from '../../../../hooks/useIntakeBlockToggle';
import { isBoolean } from 'lodash';
import { SELECT_NONE_OPTION } from '../../../../../../../../utils/noneOptionUtil';

/**
 * @todo add unit tests for ambulatory field, no should send true, and yes should send false
 */
const AmbulatoryField = () => {
  const { control } = useFormContext();
  const { isOn, isRequired } = useIntakeBlockToggle();

  if (!isOn(intakeBlocksEnum.physical)) {
    return null;
  }

  return (
    <FormControl
      className={classNames(
        styles.inputWrapper,
        styles.selectWrapper,
        styles.largeInputWrapper
      )}
      required={isRequired(intakeBlocksEnum.physical)}>
      <Controller
        name="nonAmbulatory"
        control={control}
        defaultValue={
          isRequired(intakeBlocksEnum.physical)
            ? undefined
            : SELECT_NONE_OPTION.value
        }
        render={({ field }) => (
          <Select
            options={AMBULATORY_OPTIONS.filter((v) =>
              isRequired(intakeBlocksEnum.physical)
                ? v.value !== SELECT_NONE_OPTION.value
                : true
            )}
            label="Is patient ambulatory"
            {...field}
            IconComponent={ExpandMoreIcon}
            classes={{
              select: styles.inputField,
              icon: styles.selectIcon,
            }}
            className={styles.selectRoot}
            disableUnderline
            displayEmpty={true}
            renderValue={(value) => (
              <div
                className={classNames(styles.selectValue, {
                  [styles.placeholder]: !isBoolean(value)
                })}>
                {AMBULATORY_OPTIONS?.find(
                      (option) => option?.value === value
                    )?.label || 'Select ambulatory status'}
              </div>
            )}
          />
        )}
        rules={{
          validate: (value) =>
            isRequired(intakeBlocksEnum.physical) ? isBoolean(value) : true,
        }}
      />
    </FormControl>
  );
};
export default AmbulatoryField;
